// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Trend_wrapper__1pnaA","subtitle":"Trend_subtitle__SIOmS","content":"Trend_content__1GplZ","modal_content_wrapper":"Trend_modal_content_wrapper__24WKF"};